module.exports = __webpack_public_path__ + "static/media/arrowDown.1b2fc560.svg";